<ckeditor *ngIf="isBrowser" [editor]="ckEditor" [config]="config" [data]="value ?? ''" (change)="onEditorChange($event)"
    [disabled]="isDisabled"></ckeditor>